import type { RequestedFeature } from '~/contracts/common';

export const baseLimitedRequestFeatures: RequestedFeature[] = [
  'ExcludeFacetData',
  'HideImpossibleCombos',
  'LocationBasedPrefiltering'
];
